"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "pozzaglio-ed-uniti": {
    "3f6adf32": [{
      "hkey": "7179a687",
      "slug": "brazzuoli",
      "name": "Brazzuoli",
      "primary": true,
      "skipSearch": false
    }],
    "villa-brazzuoli": [{
      "hkey": "7179a687",
      "slug": "brazzuoli",
      "name": "Brazzuoli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "491ee23a": [{
      "hkey": "74b42662",
      "slug": "villanova-alghisi",
      "name": "Villanova Alghisi",
      "primary": true,
      "skipSearch": false
    }],
    "villanuova-alghisi": [{
      "hkey": "74b42662",
      "slug": "villanova-alghisi",
      "name": "Villanova Alghisi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;